import {z} from '@hono/zod-openapi';

export const importNissanPriceListRequestSchema = z
  .object({
    fileId: z.string().min(1).openapi({example: 'a1b2c3d4-...'}),
    fileName: z.string().min(1).openapi({example: 'Nissan pricefile 2026.02 CZ.txt'}),
  })
  .openapi('ImportNissanPriceListRequest');

export type ImportNissanPriceListRequest = z.infer<typeof importNissanPriceListRequestSchema>;
